import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import RecentBlogBox from "../../Component/BlogsCMPT/RecentBlogBox";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import { BlogLimitData } from "../../APIS/FetchAPIs";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function BlogDetails() {
  const { blogslug } = useParams();
  const navigaṭe = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [ShowBlogData, setShowBlogData] = useState(true);

  const [LatestBlogLimit] = BlogLimitData(RendomTokenfetch);
  // console.log(LatestBlogLimit);

  const FetchBlogData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}blogDetailsAPI.php?blogslug=${blogslug}`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setBlogData(response.data.blogdata);
            // setShowBlogData(true);
          } else {
            setBlogData([]);
            // setShowBlogData(false);
          }
        });
    } catch (error) {
      console.error("API Error:", error);
      navigaṭe("/page-not-found", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, blogslug, navigaṭe]);

  useEffect(() => {
    FetchBlogData();
  }, [FetchBlogData, blogslug]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <title>{blogData.meta_title}</title>
        <meta name="description" content={blogData.meta_description} />
        <meta name="keywords" content={blogData.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename={blogData?.title} mainpage="blogs" />

      <section className="news-standard-section section-padding">
        <div className="container">
          <div className="gt-news-details-wrapper">
            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="gt-details-image">
                  <img
                    src={blogData.bannerImage}
                    alt={blogData.image_alt}
                    title={blogData.image_title}
                  />
                </div>
                <div className="gt-news-details-content">
                  <h3>{blogData?.title}</h3>
                  <div
                    className="mb-4"
                    dangerouslySetInnerHTML={{
                      __html: blogData.description,
                    }}
                  ></div>

                  <div className="row g-4">
                    <div
                      className="col-lg-12"
                      dangerouslySetInnerHTML={{
                        __html: blogData.description2,
                      }}
                    ></div>
                  </div>

                  <div className="row gt-tag-share-wrap mt-4 mb-5">
                    <div className="col-lg-8 col-12">
                      <div className="tagcloud">
                        <span>Tags:</span>
                        <Link to={`/blog/${blogData?.slug}`}>SmartHomes</Link>
                        <Link to={`/blog/${blogData?.slug}`}>LuxuryLiving</Link>
                        <Link to={`/blog/${blogData?.slug}`}>LegalAdvice</Link>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12 mt-3 mt-lg-0 text-lg-end">
                      <div className="social-share">
                        <Link to="/">
                          <i className="fab fa-twitter"></i>
                        </Link>
                        <Link to="/">
                          <i className="fa-brands fa-youtube"></i>
                        </Link>
                        <Link to="/">
                          <i className="fab fa-linkedin-in"></i>
                        </Link>
                        <Link to="/">
                          <i className="fab fa-facebook-f"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="gt-main-sideber sticky-style">
                  {/* <div className="gt-single-sideber-widget">
                    <div className="gt-widget-title">
                      <h3>All Categories</h3>
                    </div>
                    <ul className="gt-category-list">
                      <li>
                        <Link to={`/blog/${BlogDetails?.slug}`}>
                          City Guide
                        </Link>
                        <span>
                          <i className="flaticon-right-arrow"></i>
                        </span>
                      </li>
                      <li>
                        <Link to={`/blog/${BlogDetails?.slug}`}>
                          New Places
                        </Link>
                        <span>
                          <i className="flaticon-right-arrow"></i>
                        </span>
                      </li>
                      <li>
                        <Link to={`/blog/${BlogDetails?.slug}`}>
                          Apartments{" "}
                        </Link>
                        <span>
                          <i className="flaticon-right-arrow"></i>
                        </span>
                      </li>
                      <li>
                        <Link to={`/blog/${BlogDetails?.slug}`}>
                          Real estate{" "}
                        </Link>
                        <span>
                          <i className="flaticon-right-arrow"></i>
                        </span>
                      </li>
                      <li>
                        <Link to={`/blog/${BlogDetails?.slug}`}>
                          Luxury vilas{" "}
                        </Link>
                        <span>
                          <i className="flaticon-right-arrow"></i>
                        </span>
                      </li>
                    </ul>
                  </div> */}
                  <div className="gt-single-sideber-widget">
                    <div className="gt-widget-title">
                      <h3>Recent Post</h3>
                    </div>
                    <div className="gt-recent-post-area">
                      {loading ? (
                        <p className="text-center">Loading blogs...</p>
                      ) : LatestBlogLimit.length > 0 ? (
                        LatestBlogLimit.map((valblog, index) => (
                          <RecentBlogBox key={index} blogdata={valblog} />
                        ))
                      ) : (
                        <p className="text-center">
                          No blogs available right now.
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
